export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q05_a.761e625e.png";